export default {"src":"/_next/static/media/football_substitution_team_2.7f2e75ee.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};